// PZ PDP Mobile — поведение мобильной карточки товара
// (дизайн-хендоф design_handoff_mobile_pdp). Add-to-cart здесь НЕТ —
// это стоковый product-form-component (см. pz-pdp-buy.liquid).

// ——— Замещение старого стека товара на мобильном ———
//
// Секция прячет 12 старых секций правилом display:none, но ЭТОГО МАЛО:
// скрытые секции всё равно ломают отрисовку нашей карточки — подложки и
// подписи не рисуются, хотя раскладка и вычисленные стили верны
// («правильный дизайн появляется на мгновение и пропадает»). Доказано
// экспериментом на живой странице 2026-07-29: удаление тех же секций из
// DOM чинит картинку мгновенно, при неизменных стилях.
//
// Поэтому: CSS прячет мгновенно (без мигания старой вёрстки), а этот код
// затем выносит секции из документа. Только на мобильном и только когда
// наша карточка на странице.
//
// JSON-LD переносим в body, а не выбрасываем: разметка товара для
// поисковиков живёт в стоковой секции, а индексация у Google
// mobile-first — потерять её нельзя.
// Корни старого стека, которые его собственные скрипты ПЕРЕНОСЯТ по DOM
// (блок prod-extras всплывает наружу секции, блок цены двигает
// product-price к кнопке). Такие узлы переживают удаление секции, и
// на мобильном всплывают поверх баннера — «Steam · In stock · Digital
// download» поверх арта, плюс распирают блок с названием игры.
const LEGACY_ORPHANS = '#prod-extras, .pe-pill, .pe-region, .pe-modal, .abt, .ed-wrap, .sysreq-wrap, .nws-wrap, .sr-wrap, .desc-section, .trl-sec, .scr';

// Верхняя граница карточки. Держать В ЛОКСТЕП с медиа-запросами секции
// pz-pdp-mobile.liquid: JS чистит старый стек ровно там, где CSS его
// прячет. Рассинхрон = страница, где обе вёрстки видны одновременно.
const CARD_VIEWPORT = '(max-width: 1024px)';

const removeLegacyProductStack = () => {
  const card = document.querySelector('.pz-pdp');
  const main = document.getElementById('MainContent');
  if (!card || !main || !window.matchMedia(CARD_VIEWPORT).matches) return;

  const ourSection = card.closest('.shopify-section');
  [...main.children].forEach((section) => {
    if (section === ourSection) return;
    section.querySelectorAll('script[type="application/ld+json"]').forEach((schema) => {
      document.body.appendChild(schema);
    });
    section.remove();
  });

  // Без оглядки на то, где узел лежит. Оговорка «только снаружи нашей
  // секции» промахивалась: скрипт старого блока ищет заголовок с ценой,
  // а единственный такой на странице теперь НАШ — плашка переезжала
  // прямо в баннер и распирала блок с названием игры. Ни один из этих
  // классов нашей вёрстке не принадлежит, удалять можно где угодно.
  document.querySelectorAll(LEGACY_ORPHANS).forEach((node) => node.remove());
};

// Трижды, потому что порядок выполнения чужих скриптов не наш контракт:
// сразу (до первой отрисовки), после разбора документа и после load —
// админский код мог перенести узел уже ПОСЛЕ нашей первой уборки.
removeLegacyProductStack();
document.addEventListener('DOMContentLoaded', removeLegacyProductStack);
window.addEventListener('load', removeLegacyProductStack);

// Три прогона всё равно проигрывают гонку: скрипт старого блока может
// вставить плашку ПОСЛЕ load — на проде узел возвращался в баннер уже
// после уборки. Наблюдатель закрывает вопрос: узел удаляется в том же
// кадре, в котором появился, когда бы это ни случилось.
const watchLegacyOrphans = () => {
  if (!document.querySelector('.pz-pdp')) return;
  if (!window.matchMedia(CARD_VIEWPORT).matches) return;

  new MutationObserver(() => {
    document.querySelectorAll(LEGACY_ORPHANS).forEach((node) => node.remove());
  }).observe(document.body, { childList: true, subtree: true });
};

watchLegacyOrphans();

// Share: системный шэр; кнопка в разметке hidden — показываем только
// при поддержке API (иначе была бы мёртвая кнопка).
const shareButton = document.querySelector('[data-pz-share]');
if (shareButton && navigator.share) {
  shareButton.hidden = false;
  shareButton.addEventListener('click', () => {
    navigator
      .share({ title: document.title, url: window.location.href })
      .catch(() => {});
  });
}

// ——— Трейлер ———
//
// Оверлей — стоковый dialog-component темы: открытие и закрытие своего
// кода не требуют. Здесь единственное, чего тема не умеет: iframe
// получает src в момент открытия. Держать src в разметке нельзя — iframe
// в закрытом контейнере Chrome грузит НЕ лениво, и ~700 КБ плеера
// YouTube уехали бы к покупателю на каждой карточке ещё до тапа.
document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-pz-trailer-open]')) return;

  const frame = document.querySelector('[data-pz-trailer-src]');
  if (frame && !frame.src) frame.src = frame.dataset.pzTrailerSrc;
});

// ——— Миниатюры скриншотов ———
//
// Открывают ШТАТНЫЙ полноэкранный просмотр Shopify (zoom-dialog внутри
// блока _product-media-gallery) — своего лайтбокса не пишем (решение
// Евгения 2026-07-29).
//
// Почему не декларативным on:click="#id/open/N", как это делает сама
// тема: id диалога Shopify собирает из скрытого префикса блока —
// замер на проде 2026-07-30 дал zoom-dialog-Aa1YvbmtjWGpJVU1yR__pz-pdp-gallery,
// где префикс не равен ни section.id, ни нашему id блока. В Liquid его
// нет, поэтому связываем по факту тапа.
//
// Ссылка на полный кадр в href остаётся фолбэком: пока модуль диалога
// не доехал (или его нет вовсе), тап открывает картинку, а не молчит.
document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-pz-zoom-index]');
  if (!thumb) return;

  const zoom = document.querySelector('.pz-pdp zoom-dialog');
  if (!zoom || typeof zoom.open !== 'function') return;

  event.preventDefault();
  zoom.open(Number(thumb.dataset.pzZoomIndex), event);
});

// Раскрывашка ограничений — выбор страны и вердикт: assets/pz-pdp-country-check.js
// (подключает snippets/pz-pdp-country-check.liquid только у товара с ограничениями).
